import React from 'react';
import { useCenturionStore } from '../lib/store';
import { DayIndicator } from './DayIndicator';
import { HabitChecklist } from './HabitChecklist';
import { FinalizeButton } from './FinalizeButton';
import { isLogComplete } from '../lib/game-logic';
import { motion } from 'framer-motion';
export function CommandCenter() {
  const {
    profile,
    isLoaded,
    todayStr,
    updateHabit,
    finalizeDay
  } = useCenturionStore();
  if (!isLoaded || !profile) {
    return <div className="flex items-center justify-center min-h-[60vh]" data-id="element-113">
        <div className="animate-pulse-slow text-centurion-500 font-mono-num text-xl tracking-widest" data-id="element-114">
          INITIALIZING...
        </div>
      </div>;
  }
  const todayLog = profile.logs[todayStr];
  if (!todayLog) {
    return <div className="flex items-center justify-center min-h-[60vh]" data-id="element-115">
        <div className="text-red-500 font-mono-num text-xl tracking-widest" data-id="element-116">
          SYSTEM ERROR: NO LOG FOUND
        </div>
      </div>;
  }
  const allComplete = isLogComplete(todayLog.habits);
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} className="max-w-3xl mx-auto pb-24" data-id="element-117">
      <header className="mb-8" data-id="element-118">
        <h1 className="text-3xl font-bold tracking-tight text-gray-100 mb-2" data-id="element-119">
          Command Center
        </h1>
        <p className="text-gray-400" data-id="element-120">Log your daily actions. No excuses.</p>
      </header>

      <DayIndicator profile={profile} todayStr={todayStr} data-id="element-121" />

      <div className="bg-surface-300 rounded-xl p-1 border border-surface-100 shadow-2xl" data-id="element-122">
        <div className="bg-surface-400 rounded-lg p-4 sm:p-6" data-id="element-123">
          <div className="flex items-center justify-between mb-6 border-b border-surface-100 pb-4" data-id="element-124">
            <h2 className="text-lg font-semibold text-gray-200 uppercase tracking-wider" data-id="element-125">
              Daily Checklist
            </h2>
            <span className="text-sm font-mono-num text-gray-500" data-id="element-126">
              {todayStr}
            </span>
          </div>

          <HabitChecklist log={todayLog} onUpdate={(type, value) => updateHabit(todayStr, type, value)} disabled={todayLog.finalized} data-id="element-127" />

          <FinalizeButton isComplete={allComplete} isFinalized={todayLog.finalized} onFinalize={() => finalizeDay(todayStr)} data-id="element-128" />
        </div>
      </div>
    </motion.div>;
}